import React from "react"
import styled from "@emotion/styled"
import { breakpoints, color, wrapper } from "../../utils/style"
import { Link } from "gatsby"
import IcomoonIcon from "../shared/IcomoonIcon"
import GetWindowWidth from "../shared/GetWindowWidth"

const FooterBlock = styled("footer")`
  .item-wrap {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 32px 0;
    border-top: 1px solid ${color.pink};
  }
  .item {
    padding: 22px;
    text-align: center;
    border-radius: 4px;
    color: ${color.white};
    text-decoration: none;
    cursor: pointer;
    transition: all 0.15s;
    svg {
      margin-bottom: 16px;
    }
    &:hover {
      background: ${color.pink};
    }
  }
  .small-text {
    font-size: 12px;
    line-height: 18px;
    opacity: 0.8;
  }
  @media (max-width: ${breakpoints.md}) {
    .item {
      background: ${color.pink};
      border-radius: 0;
    }
    .small-text {
      display: none;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .item {
      flex-basis: 33.333%;
      padding: 16px 10px;
      font-size: 12px;
      line-height: 18px;
      svg {
        margin-bottom: 8px;
      }
    }
  }
`

const Wrapper = styled("div")`
  ${wrapper}
`

const Copy = styled("div")`
  width: 100%;
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
  
  span {
    opacity: 0.7;
  }
  a {
    margin: 0 0 0 20px;
    text-decoration: underline;
  }
  a:hover,
  a:active {
    text-decoration: none;
  }
`

export default () => {
  const windowWidth = GetWindowWidth()
  const isDesktop = windowWidth > 600

  const CHAT_SCRIPT_URL = "https://cdn.respond.io/webchat/widget/widget.js?cId=3e3e44cc1f52688b8d0a9e227eb8559";

  const showHideChat = () => {
    const head = document.head;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = CHAT_SCRIPT_URL;
    script.id = "respondio__widget";

    const chatScript = document.getElementById("respondio__widget");
    if (chatScript === null) {
      head.appendChild(script);
    }
  }
  return (
    <FooterBlock>
      <div className="footer-top">
        <Wrapper>
          {!isDesktop && (
            <h2 className="h1 rich-design">
              <span>ติดต่อเรา</span>
            </h2>
          )}
          <div className="item-wrap">
            <a href={`tel:${process.env.PHONE_TO_CALL}`} className="item">
              <div>
                <IcomoonIcon
                  icon="call-answer"
                  color={color.white}
                  size={isDesktop ? 52 : 34}
                />
              </div>
              <div>
                <span className="small-text">Call Center</span>
              </div>
              <div>
                <span>{process.env.PHONE_TO_DISPLAY}</span>
              </div>
            </a>
            <a
              className="item"
              href={process.env.LINE_ID_EXT}
              target="_blank"
              rel="noreferrer noopener"
            >
              <div>
                <IcomoonIcon
                  icon="line"
                  color={color.white}
                  size={isDesktop ? 52 : 34}
                />
              </div>
              <div>
                <span className="small-text">Line@</span>
              </div>
              <div>
                <span> {process.env.LINE_ID_TEXT}</span>
              </div>
            </a>

            <span
              className="item"
              role="button"
              tabIndex={0}
              onClick={() => showHideChat()}
              onKeyDown={() => showHideChat()}
            >
              <div>
                <IcomoonIcon
                  icon="chat-2"
                  color={color.white}
                  size={isDesktop ? 52 : 34}
                />
              </div>
              <div>
                <span className="small-text">LIVE CHAT</span>
              </div>
              <div>
                <span>24/7 Support</span>
              </div>
            </span>
            <Copy>
              <span>
                © All rights reserved 2023 - SCR888-VIP.COM
              </span>
              <Link to="/sitemap/">Sitemap</Link>
            </Copy>
          </div>
        </Wrapper>
      </div>
    </FooterBlock>
  )
}
